import { GlassCard, GlassCardContent, GlassCardHeader, GlassCardTitle } from '@/components/ui/glass-card'
import { Calendar, Clock, Zap } from 'lucide-react'

interface BoostStatusCardProps {
  purchasedAt: string;
  expiresAt: string;
  onRequestRefund: () => void;
  refundRequested: boolean;
}

export function BoostStatusCard({
  purchasedAt,
  expiresAt,
  onRequestRefund,
  refundRequested,
}: BoostStatusCardProps) {
  const purchaseDate = new Date(purchasedAt);
  const expiryDate = new Date(expiresAt);
  const now = new Date();

  const daysRemaining = Math.max(0, Math.ceil((expiryDate.getTime() - now.getTime()) / 86_400_000));
  const durationDays = Math.round((expiryDate.getTime() - purchaseDate.getTime()) / 86_400_000);

  const durationLabel = `${durationDays} ${durationDays === 1 ? 'day' : 'days'}`;

  return (
    <GlassCard className="border-amber-500/20 bg-gradient-to-br from-amber-500/5 to-orange-500/5">
      <GlassCardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-amber-500/20">
            <Zap className="h-5 w-5 text-amber-400" />
          </div>
          <GlassCardTitle className="text-lg">Max Boost Active</GlassCardTitle>
        </div>
      </GlassCardHeader>
      <GlassCardContent>
        <div className="space-y-3">
          <div className="flex items-center justify-between py-2 border-b border-border/30">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Calendar className="h-4 w-4" />
              Purchased
            </div>
            <span className="text-sm font-medium text-foreground">
              {purchaseDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-border/30">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              Expires
            </div>
            <div className="text-right">
              <span className="text-sm font-medium text-foreground">
                {expiryDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
              </span>
              <span className="text-xs text-muted-foreground ml-2">
                ({daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} remaining)
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Zap className="h-4 w-4" />
              Duration
            </div>
            <span className="text-sm font-medium text-foreground">
              {durationLabel}
            </span>
          </div>

          {!refundRequested && (
            <div className="pt-2 border-t border-border/30">
              <button
                onClick={onRequestRefund}
                className="text-sm text-muted-foreground hover:text-foreground underline-offset-4 hover:underline transition-colors"
              >
                Request a refund
              </button>
            </div>
          )}
          {refundRequested && (
            <div className="pt-2 border-t border-border/30">
              <span className="text-sm text-muted-foreground">
                Refund request submitted
              </span>
            </div>
          )}
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
